import { render, staticRenderFns } from "./EditMaterialVariantOrder.vue?vue&type=template&id=023551d8&scoped=true"
import script from "./EditMaterialVariantOrder.vue?vue&type=script&lang=js"
export * from "./EditMaterialVariantOrder.vue?vue&type=script&lang=js"
import style0 from "./EditMaterialVariantOrder.vue?vue&type=style&index=0&id=023551d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023551d8",
  null
  
)

export default component.exports